"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var authRedirect_1 = require("./auth/authRedirect");
exports.authenticate = function (launchApp) {
    if (exports.isAuthenticated() && launchApp) {
        launchApp();
    }
    else {
        authRedirect_1.signIn(launchApp);
    }
};
exports.isAuthenticated = function () { return authRedirect_1.getUserAccount() ? true : false; };
exports.isNewUser = function () { var _a; return ((_a = authRedirect_1.getUserAccount().idToken) === null || _a === void 0 ? void 0 : _a.newUser) === true; };
exports.signOut = function () { return authRedirect_1.logout(); };
exports.getUserId = function () { return authRedirect_1.getUserAccount().accountIdentifier; };
exports.getTenantId = function () { return authRedirect_1.getUserAccount().accountIdentifier; };
exports.getEmail = function () { return authRedirect_1.getUserAccount().idToken.emails[0]; };
exports.getFirstName = function () { return authRedirect_1.getUserAccount().idToken.given_name; };
exports.getLastName = function () { return authRedirect_1.getUserAccount().idToken.family_name; };
exports.getDisplayName = function () { return authRedirect_1.getUserAccount().name; };
exports.getCity = function () { return authRedirect_1.getUserAccount().idToken.city; };
exports.getCountry = function () { return authRedirect_1.getUserAccount().idToken.country; };
exports.getIssuer = function () { return authRedirect_1.getUserAccount().idToken.iss; };
exports.getObjectId = function () { return authRedirect_1.getUserAccount().idToken.oid; };
//# sourceMappingURL=authProvider.js.map